import createAxiosInstance from "../util/axiosInstance";

const api = createAxiosInstance('/tipoingresos');

const fetchTiposIngreso = () => {
  return api.get('/');
};

const fetchTipoIngreso = (id) => {
  return api.get(`/${id}`);
};

const createTipoIngreso = (data) => {
  return api.post('/', data);
};

const updateTipoIngreso = (id, data) => {
  return api.put(`/${id}`, data);
};

const deleteTipoIngreso = (id) => {
  return api.delete(`/${id}`);
};

export default {
  fetchTiposIngreso,
  fetchTipoIngreso,
  createTipoIngreso,
  updateTipoIngreso,
  deleteTipoIngreso,
};